module.exports = __webpack_public_path__ + "img/eBook.47c1503c.jpg";